/* eslint-disable */
import React from 'react';
import { ReferenceField, TextField, useTranslate } from 'react-admin';
import CustomReportTable from '../../../../base/components/reports/CustomReportTable';
import {  NumberField } from '../../../../base/components/ra/fields';
import resourceSlug, { REPORT_TYPES } from '../../../../constant/resource-slug';
import { LIST_REPORTS } from '../../report-rtp.list';
import TranslatableField from '../../../../base/components/ra/fields/translatable.field';

const OverallTable = () => {
  const translate = useTranslate();
  return (
    <CustomReportTable
      title={translate('resources.report.overall')}
      resource={resourceSlug.REPORT_RTP}
      reportList={LIST_REPORTS}
      reportType={REPORT_TYPES.OVERALL}
    >
      <ReferenceField link="show" source="gameId" reference="game" label="resources.game.fields.gameId">
        <TextField source="gameId" />
      </ReferenceField>
      <TranslatableField label="resources.report.fields.gameName" source="gameName" />
      <NumberField label="resources.report.fields.betCount" source="betCount" sortable />
      <NumberField label="resources.report.fields.playerCount" source="playerCount" sortable />
      <ReferenceField link="show" source="currency" reference="currency" label="resources.currency.name" sortable>
        <TextField source="code" />
      </ReferenceField>
      <TextField label="resources.report.fields.betAmount" source="betAmount" sortable />
      <TextField label="resources.report.fields.wonAmount" source="wonAmount" sortable />
    </CustomReportTable>
  );
};

export default OverallTable;
